var _style, _g, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-users_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-users_svg__st1{fill:#050505}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-users_svg__st1",
    d: "M15.1 11.9c-2 0-3.7-1.4-4-3.3-.1-.6.2-1.1.8-1.2.5-.1 1.1.2 1.2.8.2 1 1.1 1.7 2.1 1.7 1.2 0 2.1-1 2.1-2.1s-1-2.1-2.1-2.1c-.3 0-.7.1-1 .2-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.6-.3 1.2-.5 1.9-.5 2.3 0 4.1 1.8 4.1 4.1s-1.8 4.2-4.1 4.2zM22 23.3c-.6 0-1-.4-1-1 0-4.3-2.6-7.7-5.9-7.7-.2 0-.5 0-.7.1-.5.1-1.1-.3-1.1-.8-.1-.5.3-1.1.8-1.1.3-.1.7-.1 1-.1 4.4 0 7.9 4.4 7.9 9.7 0 .5-.4.9-1 .9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-users_svg__st1",
    d: "M10 10c-2.6 0-4.6-2.1-4.6-4.6C5.4 2.8 7.5.8 10 .8s4.6 2.1 4.6 4.6c.1 2.5-2 4.6-4.6 4.6zm0-7.3c-1.5 0-2.6 1.2-2.6 2.6S8.6 8 10 8s2.6-1.2 2.6-2.6-1.1-2.7-2.6-2.7zM18.1 23.3c-.6 0-1-.4-1-1 0-5.1-3.2-9.2-7-9.2-3.9 0-7 4.1-7 9.2 0 .6-.4 1-1 1s-1-.4-1-1c0-6.2 4.1-11.2 9-11.2 5 0 9 5 9 11.2 0 .6-.5 1-1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-users_svg__st1",
    d: "M11.7 16.3l-1.1 4c-.2.5-.9.5-1.1 0l-1.2-3.9c-.1-.2 0-.5.2-.6l1.2-.8c.2-.1.5-.1.7 0l1.1.8c.2 0 .3.2.2.5z"
  })));
}

export default SvgIconUsers;